import * as React from 'react';

const EyeMagnifyingGlass24 = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M10.5 13.5a2 2 0 1 0-1.75-2.968 1 1 0 1 1 0 1.937A2 2 0 0 0 10.5 13.5"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M7.1 9.45c.417-.556 1.72-1.7 3.4-1.7s2.983 1.144 3.4 1.7a.75.75 0 0 0 1.2-.9c-.583-.777-2.28-2.3-4.6-2.3s-4.017 1.523-4.6 2.3a.75.75 0 0 0 1.2.9"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M15.956 17.018a8.5 8.5 0 1 1 1.06-1.06l4.513 4.512a.75.75 0 0 1-1.06 1.06zM17.5 10.5a7 7 0 1 0-14 0 7 7 0 0 0 14 0"
  }
));
EyeMagnifyingGlass24.Size = 24;
EyeMagnifyingGlass24.Title = "EyeMagnifyingGlass";

export { EyeMagnifyingGlass24 as default };
